import * as React from 'react';
import classNames from 'classnames';
import {DropdownV2} from '@priority-software/priority-style-react';
import {DropdownContent} from './FormDropdownContent';
import {FieldSearchDropdownProps} from '../../../components/Common/FieldSearch/types/DropdownProps';
import {iSearchDropdownCloseKey} from '../utils/keys';
import dropdownPartsStyles from '../../../components/Common/FieldSearch/components/SearchParts/styles.module.scss';

export const HoveringDropdown = (props: FieldSearchDropdownProps) => {
    const {dropdownStyle, isSearchable, onClose, onKeyDown, className, column} = props;
    const upword = dropdownStyle.top === 'auto';
    const contentClass = classNames({
        [dropdownPartsStyles.flipContent]: upword && isSearchable
    });

    return (
        <DropdownV2
            isOpen
            oldStyles
            componentClasses={className}
            style={dropdownStyle}
            contentComponentClasses={contentClass}
            forceUpward={upword}
            onClose={onClose}
            onKeyDown={onKeyDown}
            isCloseKeyCallback={iSearchDropdownCloseKey}
        >
            <DropdownContent
                {...props}
                onClose={onClose}
                hasStatus={column?.isStatus}
                dropdownStyle={dropdownStyle}
            />
        </DropdownV2>
    );
};
